// @flow
import React, {PureComponent} from 'react';

type Props = {|
    width?: number | 'auto',
    isVirtualizedCells: boolean,
|};

class DataTablePlaceholderCell extends PureComponent<Props> {
    static defaultProps = {
        width: 0
    };

    render() {
        if (!this.props.isVirtualizedCells) {
            return null;
        }

        const styles = {width: this.props.width};

        return (
            <div style={styles} className="data-table__cell-placeholder"/>
        );
    }
}

export {DataTablePlaceholderCell};
